module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-1297-retro.b78dc9ca.jpg";